import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { get, post } from "../../services/api";

function NavCategoryList() {
  const token = localStorage.getItem("token");
  const [studentsData, setCategoryData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentCategory, setCurrentCategory] = useState({ id: "", name: "" });
  const [isEditMode, setIsEditMode] = useState(false);

  const getCategoryList = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get("UserAuthentication/GetAllCategory", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setCategoryData(response.navCategory);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    getCategoryList();
  }, []);

  const handleEdit = async (id) => {
    var formdata = { id: id };
    try {
      const response = await post(
        `UserAuthentication/GetCategoryById`,
        formdata,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCurrentCategory(response.navCategory); // Assuming the response is directly the category object
      setIsEditMode(true);
      setModalVisible(true);
    } catch (error) {
      console.error("Error fetching category:", error);
    }
  };

  const handleDelete = async (id) => {
    // Show confirmation dialog
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this category?"
    );

    // If the user confirms the deletion
    if (confirmDelete) {
      const formdata = { id: id };
      try {
        const response = await post(
          `UserAuthentication/DeleteNavCategory`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // Refresh the category list after deletion
        getCategoryList();
      } catch (error) {
        console.error("Error deleting category:", error);
      }
    } else {
      console.log("Deletion canceled.");
    }
  };

  const handleCreate = () => {
    setCurrentCategory({ id: "", name: "" });
    setIsEditMode(false);
    setModalVisible(true);
  };

  const handleSave = async () => {
    const saveId = currentCategory.id ? currentCategory.id : 0;
    var formdata = { id: saveId, name: currentCategory.name };
    try {
      const response = await post(
        `UserAuthentication/AddUpdateNavCategory`,
        formdata,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setModalVisible(false);
      getCategoryList(); // Refresh the category list after save
    } catch (error) {
      console.error("Error fetching category:", error);
    }
  };

  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "Category Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div>
          <button
            className="btn btn-outline-primary py-1 px-2 lh-2"
            onClick={() => handleEdit(row.id)}
          >
            Edit
          </button>
          <button
            className="btn btn-outline-danger py-1 px-2 lh-2"
            onClick={() => handleDelete(row.id)}
          >
            Delete
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div>
      <button
        className="btn btn-outline-primary py-1 px-2 lh-2"
        onClick={handleCreate}
        style={{ marginBottom: "10px" }}
      >
        Create
      </button>
      <DataTable columns={columns} data={studentsData} pagination dense />

      {modalVisible && (
        <div className="modal" style={modalStyles}>
          <div className="modal-content" style={modalContentStyles}>
            <h2>{isEditMode ? "Edit Category" : "Create Category"}</h2>
            <div>
              <label>ID:</label>
              <input
                type="text"
                value={currentCategory.id}
                readOnly
                style={inputStyles}
              />
            </div>
            <div>
              <label>Category Name:</label>
              <input
                type="text"
                value={currentCategory.name}
                onChange={(e) =>
                  setCurrentCategory({
                    ...currentCategory,
                    name: e.target.value,
                  })
                }
                style={inputStyles}
              />
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                onClick={handleSave}
                className="btn btn-outline-success"
                style={{ marginRight: "10px" }}
              >
                Save
              </button>
              <button
                onClick={() => setModalVisible(false)}
                className="btn btn-outline-secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const modalStyles = {
  display: "flex",
  position: "fixed",
  zIndex: 1000,
  left: 0,
  top: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  justifyContent: "center",
  alignItems: "center",
};

const modalContentStyles = {
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "8px",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
  width: "400px", // Set a width for the modal
  maxWidth: "90%", // Responsive max width
};

const inputStyles = {
  margin: "10px 0",
  padding: "8px",
  width: "100%",
  boxSizing: "border-box",
};

export default NavCategoryList;
